import axios from "axios";
import moment from "moment";
import { API_ADDRESS, API_COINGEKO } from "../../constants/config";

export class GlobalStatsService {
  public fetchGlobalStats = async () => {
    try {
      const contractData: any = axios.get(
        `${API_ADDRESS}/public/contract/info`
      );
      const priceData: any = axios.get(`${API_ADDRESS}/public/contract/price`);
      const cashPriceData: any = axios.get(
        `${API_COINGEKO}/v3/simple/price?ids=centric-cash&vs_currencies=usd`
      );
      const [
        { data: contractResult },
        { data: priceResult },
        { data: cashPriceResult },
      ] = await Promise.all([contractData, priceData, cashPriceData]);
      const { cash: cashRaw, rise } = contractResult;
      const { current, next } = priceResult;
      const { usd: cashPrice } = cashPriceResult["centric-cash"];
      const cash = {
        ...cashRaw,
        priceInDecimal: cashPrice,
      };
      const now = moment();
      const priceBlock = Math.floor(moment(now).unix() / 60 / 60);
      const protocolClaim =
        cash.circulatingSupplyInDecimal / current.priceInDecimal;
      const protocolRate = Number((1/current.priceInDecimal).toFixed(4));
      return {
        cash,
        rise,
        current,
        next,
        priceBlock,
        protocolClaim,
        protocolRate,
      };
    } catch (e) {
      console.log(e);
      throw Error(e.message);
    }
  };
}
